<template>
  <svg viewBox="0 0 18 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="#FFF" fill-rule="nonzero">
      <path
        d="M4.781 11.84C3.3 10.378 2.794 8.342 3.225 6.454l1.594.518L3.675 2.4 0 5.417l1.613.518a7.424 7.424 0 0 0 1.968 7.09c2.269 2.24 5.644 2.758 8.419 1.517l-.412-1.665c-2.194 1.129-4.97.777-6.807-1.037ZM15.982 9.264a7.412 7.412 0 0 0-1.974-7.091C11.732-.067 8.365-.567 5.6.636l.414 1.666c2.2-1.092 4.965-.74 6.79 1.056 1.486 1.462 1.993 3.499 1.56 5.387l-1.598-.518 1.147 4.573L17.6 9.782l-1.618-.518Z"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>
